import {
  IconBook,
  IconBrickWall,
  IconCheck,
  IconUser,
  IconUserStar,
  IconWrench,
} from "@mitosis/frontend-base/icons";
import { Role } from "@mitosis/frontend-base";

export const ROLE_NAMES: Record<Role, string> = {
  personnel: "Personel",
  management: "Zarządzanie",
  knowledge: "Wiedza",
  verification: "Weryfikacja",
  configuration: "Konfiguracja",
  supervisor: "Supervisor",
};

export const ROLE_ICONS: Record<Role, () => HTMLElement> = {
  personnel: IconUser,
  management: IconUserStar,
  knowledge: IconBook,
  verification: IconCheck,
  configuration: IconWrench,
  supervisor: IconBrickWall,
};

type Link = { [key: string]: Link } | (() => string) | ((arg: any) => string);
export const links = {
  // Base
  home: () => "/",
  notFound: () => "/404/",
  // Auth
  login: () => "/auth/login/",
  emailLogin: () => "/auth/login/email/",
  unauthorized: () => "/auth/unauthorized/",
  unauthenticated: () => "/auth/unauthenticated/",
  loggedOut: () => "/auth/logged-out/",
  // Roles
  selectRole: () => "/select-role/",
  role: (role: Role) => `/roles/${role}/`,
  // Chat
  chatInstructions: () => "/chat-instructions/",
  chatInfo: () => "/chat-info/",
  chatPatient: () => "/chat-patient/",
  chatReception: () => "/chat-reception/",
  // Users
  users: () => "/users/",
  // Conversation comments
  conversationComments: () => "/conversation-comments/",
  conversationComment: (id: string) => `/conversation-comments/comment/#${id}`,
  // Announcements
  announcements: () => `/announcements/`,
  // Docs
  generalDocumentation: () => `/general-documentation/`,
  roleDocumentation: (role: Role) => `/documentation/${role}`,
  terms: () => `/terms/`,
  // Files
  files: () => "/files/",
  draft: (id) => `/files/draft/#${id}`,
  file: (id) => `/files/file/#${id}`,
} satisfies Record<string, Link>;

type Module =
  | "announcements"
  | "conversationComments"
  | "users"
  | "knowledge"
  | "documentation";

export const PERMISSIONS = {
  announcements: {
    create: ["knowledge"] as Role[],
    delete: ["knowledge"] as Role[],
  },
  knowledge: {
    view: ["knowledge", "management"] as Role[],
    create: ["knowledge"] as Role[],
    edit: ["knowledge"] as Role[],
  },
  conversationComments: {
    view: ["management", "knowledge"] as Role[],
    create: ["verification", "management", "knowledge"] as Role[],
    delete: ["knowledge"] as Role[],
  },
  users: {
    manage: ["configuration"] as Role[], // view, create, edit and delete
  },
  documentation: {
    view: ["knowledge"] as Role[],
  },
} satisfies Record<
  Module,
  Partial<Record<string, Role[]>>
>;
